<template>
  <v-expansion-panel-content
    ref="calendarStep"
    class="process-step-header"
    :disabled="disabled"
    :aria-disabled="disabled"
  >
    <div slot="header">
      <div class="flex">
        <div class="process-number">{{processNumber}}</div>
        <div class="process-step-name">{{messages.selectDateTimeStep}}</div>
      </div>
      <div v-if="displaySelectedDateTime" class="chosen-options">
        <small>
          <div>{{selectedDate | formatDate(selectedLanguage)}} {{selectedTimeSlot | formatTime(selectedLanguage)}}</div>
        </small>
      </div>
    </div>
    <v-card>
      <v-card-text class="info-text" tabindex="0">{{messages.selectDateTimeContentText}}</v-card-text>
      <time-selection
        v-if="loadCalendar"
        :reschedule="false"
        @time-selected="timeSelected"
        @timeslot-cleared="timeslotCleared"
        @is-loaded="$emit('is-loaded')"
      ></time-selection>
    </v-card>
  </v-expansion-panel-content>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import TimeSelection from '../components/TimeSelection'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'DateTimeSelectionStep',
  props: [
    'disabled',
    'processNumber',
    'loadCalendar',
    'displaySelectedDateTime'
  ],
  components: {
    TimeSelection
  },
  data: () => ({

  }),
  watch: {

  },
  computed: {
    ...mapState([
      'configuration',
      'selectedDate',
      'selectedTimeSlot',
      'messages',
      'selectedLanguage',
      'funcDebug'
    ])
  },
  methods: {
    ...mapActions([
      'resetSelectedDateAndTimeSlot',
      'setSelectedDate',
      'setSelectedTimeSlot',
      'setContactDetails',
      'resetContactDetails',
      'resetBookingStore',
      'setReservedAppointmedId'
    ]),
    timeslotCleared () {
      this.$emit('update:displaySelectedDateTime', false)
      this.setReservedAppointmedId(null)
    },
    timeSelected (timeslot, date, appointmentId) {
      if (this.funcDebug) console.log('DateTimeSelectionStep:methods:timeSelected')
      this.setSelectedDate(date)
      this.setSelectedTimeSlot(timeslot)
      this.setReservedAppointmedId(appointmentId)
      this.$emit('update:displaySelectedDateTime', false)
      this.$emit('data-selected', 'date-time')
    },
    setfocus () {
      var _this = this
      this.$nextTick(() => {
        _this.$refs.calendarStep.$el.focus()
      })
    }
  },
  mounted () {
    if (this.funcDebug) console.log('DateTimeSelectionStep:mounted')
    eventHub.$on('date-time-step-focus', this.setfocus)
  }
}
</script>

<style scoped lang="scss">
</style>
